import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  width: 100%;

  textarea {
    min-height: 100px;
  }
`

export const Label = styled.label`
  font-size: 12px;
  font-weight: 700;
  line-height: 24px;
  margin: 0 0 4px 16px;
`

export const Input = styled.input`
  background-color: #FCF8EF;
  border: none;
  border-radius: 10px;
  font-weight: 300;
  height: 45px;
  outline: none;
  padding: 13px 16px;
  width: 100%;

  &::placeholder {
    color: #7E8691;
    font-size: 16px;
    line-height: 24px;
    font-style: italic;
    max-width: 250px;
  }

  &[type="date"]::-webkit-inner-spin-button,
  &[type="date"]::-webkit-calendar-picker-indicator {
    filter: invert(1);
  }

  @media (max-width: 764px) {
    font-size: 12pt;
    height: 46px;
  }
`
